<div id="accept-modal">
  <span class="close-button" [mat-dialog-close]="false" tabindex="0" role="button">
    <img src="./assets/icons/icon_close.svg" alt="close-dialog">
  </span>
  
  <div class="accept-content">

    <div class="modal-title">
      <h2>{{modalData.title | translate}}</h2>
    </div>
    <div class="accept-modal-body">
      {{modalData.body  | translate  }}
    </div>

  </div>

  <div class="footer">
    <div *ngIf="modalData?.buttons?.btn1 ">
      <button [mat-dialog-close] = "false" class="hp-secondary-btn btn-space-left">{{modalData?.buttons?.btn1 | translate}}</button>
    </div>
    <div *ngIf="modalData?.buttons?.btn2">
      <button class="hp-primary-btn btn-space-left" (click)="navigate()">{{modalData?.buttons?.btn2 | translate}}</button>
    </div>



  </div>
</div>

